import amplitude from 'amplitude-js';

import { AMPLITUDE_EVENT } from './constants';
import { sendMessageToApp } from './webview';

export async function trackTempPurchase(data: { [key: string]: any }): Promise<void> {
  amplitude.getInstance().logEvent(AMPLITUDE_EVENT.SUBMIT_REQUEST, {
    'location': window.location.pathname,
    'origin': window.location.origin,
  });

  // @ts-ignore
  const { branch, fbq, dataLayer } = window;

  if (branch) {
    try {
      await Promise.all([
        new Promise((resolve, reject) => {
          branch.logEvent('INITIATE_PURCHASE', { ...data }, (err: Error) => {
            if (err) {
              console.error("Fail send 1 'INITIATE_PURCHASE' event: ", err);
              reject(err);
            } else {
              resolve(null);
            }
          });
        }),
        new Promise((resolve, reject) => {
          branch.logEvent('lead_rfq_internettv-rfq', { ...data }, (err: Error) => {
            if (err) {
              console.error("Fail send 1 'lead_rfq_internettv-rfq' event: ", err);
              reject(err);
            } else {
              resolve(null);
            }
          });
        }),
      ]);
    } catch (error) {
      console.error('One or more events failed: ', error);
    }
  }

  dataLayer.push({
    user_id: data.phone,
    crm_id: data.phone,
  });

  if (fbq) fbq('track', 'Purchase', { value: 0, currency: 'KRW' });
}

interface SendFbqEventProps {
  event?: React.MouseEvent<HTMLAnchorElement, MouseEvent>;
  eventName: string;
}

export const sendFbqEvent = async ({ event, eventName }: SendFbqEventProps) => {
  // @ts-ignore
  const { fbq } = window;

  if (event == null) {
    const pathname = window.location.pathname;
    const pathnameArr = pathname.split('/');
    const path = pathnameArr[pathnameArr.length - 2];
    const fbqEventName = eventName + path;

    if (fbq) {
      fbq('trackCustom', fbqEventName, {
        pathname: pathname,
      });
    }
    return;
  }

  const href = event.currentTarget.href;
  if (href.includes('/?go')) return;

  const pathname = event.currentTarget.pathname;
  const pathnameArr = pathname.split('/');
  const path = pathnameArr[pathnameArr.length - 2];
  const fbqEventName = eventName + path;

  if (fbq) {
    fbq('trackCustom', fbqEventName, {
      pathname: pathname,
    });
  }
};

export function sendAmplitudeEvent(eventName: string, properties = {}): void {
  if (!eventName) return;
  properties = {
    from: 'misoWeb',
    ...properties,
  };
  if (process.env.NODE_ENV === 'development') {
    console.warn('analytics.sendAmplitudeEvent', eventName, properties);
    return;
  }
  amplitude.getInstance().logEvent(eventName, properties);
}

export type AnalyticsTrackEvent = {
  type: 'log-event';
  data: {
    eventName: (typeof eventNames)[keyof typeof eventNames];
    properties?: Record<string, unknown>;
  };
};

export const eventNames = {
  OPEN_TICKET_LIST: 'Open Ticket List',
  OPEN_TICKET_DETAIL: 'Open Ticket Detail',
} as const;

export const track = ({ eventName, properties }: AnalyticsTrackEvent['data']) => {
  sendMessageToApp({
    type: 'log-event',
    data: {
      eventName,
      properties,
    },
  });
};

export const analytics = {
  eventNames,
  track,
};
